// Track all "Click" events on A and Button elements
// Track all "Toggle" events on Details elements
document.addEventListener('click', function (e) {
  const isLink =
    e.target.tagName === 'A' ||
    e.target.tagName === 'BUTTON' ||
    e.target.closest('a') ||
    e.target.closest('button') ||
    e.target.tagName === 'MODAL-TRIGGER';

  const isProductInfoButton = e.target.closest('.product-information');

  if (isLink) {
    const link = e.target.closest('a') || e.target.closest('button') || e.target.closest('modal-trigger');

    const classesToIgnore = [
      'mini-cart__product', // ignore clicks on mini cart products
      'swatch-group__item-button', // ignore clicks on swatch buttons
      'mini-cart__add-to-cart', // ignore clicks on mini cart add to cart buttons
      'quantity__button', // ignore clicks on quantity buttons
      'cart-item__remove', // ignore clicks on cart items
      'facets__label', // ignore clicks on collection grid filters
      'collection-grid__item', // ignore clicks on collection grid items
      'switch-view-buttons', // ignore clicks on PLP switch view buttons
    ];
    if (classesToIgnore.some((className) => link?.classList.contains(className) || link?.closest(`.${className}`))) {
      return;
    }

    // if links to a file, then track it as a "File Downloaded" event
    if (link?.href?.includes('.pdf')) {
      trackFileDownloaded(e);
      return;
    }

    trackLinkClick(e);
  } else if (e.target.tagName === 'IMG') {
    const link = e.target.closest('a') || e.target.closest('button');

    if (!link) return;

    const classesToIgnore = [
      'mini-cart__product',
      'swatch-group__item-button',
      'mini-cart__add-to-cart',
      'quantity__button',
      'cart-item__remove',
    ];
    if (classesToIgnore.some((className) => link.classList.contains(className))) return;

    if (link.tagName === 'A') {
      trackLinkClick(e);
    }
  } else if (e.target.closest('summary')) {
    if (window.location.pathname.includes('/products/') && e.target.closest('animated-accordion-mobile-slideover')) {
      if (e.target.closest('animated-accordion-mobile-slideover').id == 'additional-items') {
        setTimeout(function () {
          handleAdditionalProductAccordionExpanded(e);
        }, 1000);
      } else {
        setTimeout(function () {
          handleProductOptionExpanded(e);
        }, 1000);
      }
      // if (e.target.parentElement.parentElement.classList.contains('animated-accordion-mobile-slideover__title')) {
      //   handleProductAccordionExpanded(e);
      // } else if (e.target.parentElement.classList.contains('option-accordion')) {
      //   handleProductOptionExpanded(e);
      // } else if (e.target.parentElement.classList.contains('additional-items__items')) {
      // }
    } else {
      // console.log('untracked summary click', e.target.tagName, e.target.parentElement.classList);
    }
  }
});

function trackLinkClick(e) {
  e && e.preventPropagation && e.preventPropagation();

  const target = e.target,
        link = 
          target.closest('[data-click]') ||
          target.closest('a') ||
          target.closest('button') ||
          target.closest('modal-trigger');

  if (!link) return;

  const clickData = {
          element: { // comes from Shopify data structure: https://shopify.dev/docs/api/web-pixels-api/dom-events/clicked
            href: link.dataset.href || link.href,
            id: link.id,
            name: link.name,
            tagName: link.tagName,
            type: link.type,
            value: link.value,
            text: link?.dataset.text || link.innerText,
            classList: link.classList.toString(),
            section_name: e.target.closest('[data-section-name')?.dataset.sectionName || null,
            section_id: e.target.closest('[data-section-id')?.dataset.sectionId || null,
            section_shopify_id: e.target.closest('.shopify-section')?.id || null
          },
          parentClassList: link.parentElement.classList.toString(),
          movementX: e.movementX,
          movementY: e.movementY,
          offsetX: e.offsetX,
          offsetY: e.offsetY,
          pageX: e.pageX,
          pageY: e.pageY,
          screenX: e.screenX,
          screenY: e.screenY,
        }
  let eventName = link.dataset.click || 'click',
      properties = {}

  if (target.tagName.indexOf('MODAL-TRIGGER') > -1) eventName = 'modal_opened';
  if (target.closest('.modal__toggle')) eventName = 'modal_closed';
  if (target.closest('.product-information')) eventName = 'pdp_button_clicked';
  if (target.closest('.faqs-section__tab')) {
    clickData.element.href = `${location.pathname.split('/').slice(0,-1).join('/')}/${link.dataset.href}`;

    const faqsSectionLastUrl = target.closest('faqs-section')?.dataset?.lastUrl;
    if (faqsSectionLastUrl) properties.page_path = faqsSectionLastUrl;
  }
  if (target.closest('.care-tabs')) {
    if (target.classList.contains('care-tabs__tab')) {
      properties.l1 = target.innerText || null;
    } else if (target.classList.contains('care-tabs__subtab')) {
      properties.l1 = document.querySelector('.care-tabs__tab--active')?.innerText || null;
      properties.l2 = target.innerText || null;
    } else if (target.classList.contains('care-tabs__dialog-option') || target.classList.contains('care-tabs__sidenav-item')) {
      properties.l1 = document.querySelector('.care-tabs__tab--active')?.innerText || null;
      properties.l2 = document.querySelector('.care-tabs__subtab--active')?.innerText || null;
      properties.l3 = target.innerText || null;
    } else if (target.classList.contains('care-tabs__dialog-close')) {
      properties.l1 = document.querySelector('.care-tabs__tab--active')?.innerText || null;
      properties.l2 = document.querySelector('.care-tabs__subtab--active')?.innerText || null;
      properties.l3 = 'Close L3 Care Modal'
    } else if (target.classList.contains('care-tabs__mobile-button')) {
      properties.l1 = document.querySelector('.care-tabs__tab--active')?.innerText || null;
      properties.l2 = document.querySelector('.care-tabs__subtab--active')?.innerText || null;
      properties.l3 = 'Open L3 Care Modal'
    }
    console.log('care tab clicked', ' \n', properties.l1, ' \n', properties.l2, ' \n', properties.l3);
  }

  if (target.closest('.materials-gallery__modal-option')) {
    eventName = 'material_variant_viewed';
    properties = {
      category: target.closest('[data-option]').dataset.title,
      name: target.closest('[data-option]').dataset.variantTitle
    }
  } 

  Shopify.analytics.publish(eventName, {clickData: clickData, ...properties});
    
  // console.log('trackLinkClick', {clickData: clickData, ...properties});
}

function trackFileDownloaded(e) {
  e && e.preventPropagation && e.preventPropagation();

  const target = e.target.closest('a');
  const fileExtension = target.pathname.split('.').pop();
  const downloadData = {
    element: {
      // comes from Shopify data structure: https://shopify.dev/docs/api/web-pixels-api/dom-events/clicked
      href: target.href,
      id: target.id,
      tagName: target.tagName,
      value: target.value,
      text: target.innerText,
      classList: target.classList.toString(),
      section_name: e.target.closest('[data-section-name')?.dataset.sectionName || null,
      section_id: e.target.closest('[data-section-id')?.dataset.sectionId,
      section_shopify_id: e.target.closest('.shopify-section')?.id,
    },
    parentClassList: target.parentElement.classList.toString(),
    file_name: target.pathname.split('\\').pop().split('/').pop(),
    file_extension: fileExtension,
  };
  if (target) {
    Shopify.analytics.publish('file_downloaded', { clickData: downloadData });
  }
}

document.addEventListener('click', function (e) {
  if (e.target.closest('.facets__label')) {
    trackFilterApplied(e);
  }

  // on pause for now - will likely be used only for cross/up-sell products in carousels...etc.
  // if (e.target.closest('.collection-grid__item')) {
  //   trackGridProductClicked(e);
  // }
});

function trackFilterApplied(e) {
  const label = e.target.closest('.facets__label'),
    input = label.parentElement.querySelector('input'),
    id = input.id,
    name = input.name;
  value = input.value;
  valueFull = label.querySelector('.facet-checkbox__text-label').innerText;
  const labelValue =
    e.target.closest('.facets__disclosure')?.querySelector('.facets__summary-label').innerText ||
    e.target.closest('.mobile-facets__details')?.querySelector('.mobile-facets__summary > div').innerText;
  const target = e.target;
  const filterData = {
    toggle: input.checked ? 'off' : 'on', // because we're targeting from the label, this fires before the input is checked
    element: {
      // comes from Shopify data structure: https://shopify.dev/docs/api/web-pixels-api/dom-events/clicked
      id: id,
      name: name,
      value: value,
      value_full: valueFull,
      label: labelValue,
      section_name: e.target.closest('[data-section-name')?.dataset.sectionName || null,
      section_id: e.target.closest('[data-section-id')?.dataset.sectionId,
      section_shopify_id: e.target.closest('.shopify-section')?.id,
    },
  };
  if (target) {
    Shopify.analytics.publish('product_list_filtered', { clickData: filterData });
  }
}

// Need to revisit this function to balance when/where we want it with overburdening the tile code
function trackGridProductClicked(e) {
  debugger;

  const productData = {
    ProductVariant_id: asdf,
    sku: asdf,
    category: asdf,
    name: asdf,
    variants: asdf,
    price: asdf,
    page_path: asdf,
    image_url: asdf,
    weeks: asdf,
    page_type: asdf,
    link_location_id: asdf,
  };

  Shopify.analytics.publish('product_clicked', { clickData: productData });
}

// Fire product_option_expanded event when a user expands an accordion on the PDP
function handleProductOptionExpanded(e) {
  const option = e.target.closest('details');
  if (!option.open) return;

  const label = e.target.querySelector('.option-accordion__option-label')?.innerText;

  const optionData = {
    id: option.id,
    label: label,
    classList: option.classList.toString(),
    expanded: option.getAttribute('open'),
    name: option.name,
  };
  // console.log('product_option_expanded', accordionData);
  Shopify.analytics.publish('product_option_expanded', {
    clickData: optionData,
    option_name: label,
    link_location_id: 'Buy Box',
  });
}

// Fire product_accordion_expanded event when a user expands an accordion on the PDP
function handleProductAccordionExpanded(e) {
  const accordion = e.target.closest('details');
  if (!accordion.open) return;

  const title = e.target.querySelector('.summary__title')?.innerText;

  const accordionData = {
    id: accordion.id,
    title: title,
    classList: accordion.classList.toString(),
    expanded: accordion.getAttribute('open'),
    name: accordion.name,
  };
  // console.log('product_accordion_expanded', accordionData);
  Shopify.analytics.publish('product_accordion_expanded', { clickData: accordionData });
}

function handleAdditionalProductAccordionExpanded(e) {
  const accordion = e.target.closest('details');
  if (!accordion.open) return;

  const title = e.target.innerText;

  const accordionData = {
    id: accordion.id,
    title: title,
    classList: accordion.classList.toString(),
    expanded: accordion.getAttribute('open'),
    name: accordion.name,
  };
  // console.log('product_accordion_expanded', accordionData);
  Shopify.analytics.publish('product_additional_items_accordion_expanded', { clickData: accordionData });
}

// Track all "Details Opened" events
// document.querySelectorAll('details').forEach(function(detail) {
//   detail.addEventListener('toggle', trackDetailsOpened);
// });

// function trackDetailsOpened (e) {
//   if (!e.target.open) return;
//   e && e.preventPropagation && e.preventPropagation();
//   const target = e.target;
//   const detailsData = {
//     element: { // comes from Shopify cliecked data structure: https://shopify.dev/docs/api/web-pixels-api/dom-events/details-opened
//       id: target.id,
//       name: target.name,
//       tagName: target.tagName,
//       open: target.open,
//       classList: target.classList.toString(),
//     },
//     parentClassList: target.parentElement.classList.toString(),
//   }
//   if (target) {
//     Shopify.analytics.publish("details_toggled_open", detailsData);
//   }
// }

// Track Page Scrolling in Events
window.addEventListener('load', function (event) {
  window.addEventListener('scroll', scrollHandler, { passive: true });
});

var is25ScrollFired = false;
var is50ScrollFired = false;
var is75ScrollFired = false;
var is100ScrollFired = false;

function scrollHandler() {
  var scrollTop = window.scrollY;
  var scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
  var scrollPercent = scrollTop / scrollHeight;
  var scrollPercentRounded = Math.round(scrollPercent * 100);

  if (!is25ScrollFired && scrollPercentRounded > 25 && scrollPercentRounded < 50) {
    Shopify.analytics.publish('scroll', { percent: 25 });
    is25ScrollFired = true;
  } else if (!is50ScrollFired && scrollPercentRounded >= 50 && scrollPercentRounded < 75) {
    Shopify.analytics.publish('scroll', { percent: 50 });
    is50ScrollFired = true;
  } else if (!is75ScrollFired && scrollPercentRounded >= 75 && scrollPercentRounded < 100) {
    Shopify.analytics.publish('scroll', { percent: 75 });
    is75ScrollFired = true;
  } else if (!is100ScrollFired && scrollPercentRounded >= 90) {
    Shopify.analytics.publish('scroll', { percent: 90 });
    is100ScrollFired = true;
  }
}

// Fire form started event when a user starts filling out a form
window.formsStarted = [];
window.addEventListener('focusin', function (e) {
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
    const form = e.target.closest('form');
    if (form && !form.classList.contains('facets__form') && !form.classList.contains('mobile-facets')) {
      if (window.formsStarted.includes(form.id)) return;
      window.formsStarted.push(form.id);

      if (form.action.indexOf('powerfulform') > -1) {
        name = Globo.FormBuilder.forms[form.dataset.id].elements[0].label.en;
      }

      const properties = {
        id: form.id,
        form_name: e.target.closest('[data-section-id')?.dataset.sectionId || name,
        action: form.action,
      };

      if (document.title && location.href?.indexOf('/products/') > -1) properties.product_title = document.title;

      // Check if form is within footer
      if (form.closest('.footer')) {
        properties.form_name = 'Email Capture';
      }

      Shopify.analytics.publish('form_started', properties);
    }
  }
});

// Fire Signup Event when user submits a Klaviyo form
window.addEventListener('klaviyoForms', function (e) {
  if (!e.detail.metaData) return;

  // loop through each detail property and remove $ from the property name.
  var metaData = {};
  for (var key in e.detail.metaData) {
    metaData[key.replace('$', '')] = e.detail.metaData[key];
  }

  if (metaData.email || metaData.phone) {
    Shopify.analytics.visitor({
      email: metaData.email,
      phone: metaData.phone,
    });
  }

  // if (e.target.querySelector('.has-error')) {
  //   console.log('form_error', { id: `Globo Form ${e.target.dataset.id}`, ...formData });
  //   Shopify.analytics.publish("form_error", { id: `Globo Form ${e.target.dataset.id}`, ...formData });
  //   return;
  // }

  metaData.form_name = 'Email Capture';
  metaData.action = 'Email List';

  if (e.detail.type == 'submit') {
    // change event to standard "form_submitted" event when Shopify enables this (it is blocked for now)
    Shopify.analytics.publish('form_completed', { id: metaData.formId, ...metaData });
    publish(PUB_SUB_EVENTS.listSignup, { id: metaData.formId, ...metaData });
  }
});

// Reviews Events
// reviews_opened and review_started events tracked in pdp.reviews.liquid

// Fire form event when a user submits a Globo Form Builder form
window.addEventListener('delayedLoad', function () {
  const gforms = document.querySelectorAll('.g-container');
  if (gforms) {
    gforms.forEach((form) => {
      // console.log('gform found', form);

      // set hidden fields
      if (form.querySelector('.globo-form-control:has([data-label="link_location_id"])')) {
        const linkLocationId = form.querySelector('.globo-form-control:has([data-label="link_location_id"]) input');
        linkLocationId.value = linkLocationId.closest('[data-section-id')?.dataset.sectionId;
      }

      // add listener
      form.addEventListener('submit', (e) => {
        const userData = {};
        const formData = {};
        let firstTextAreaFound = false;
        e.target.querySelectorAll('input, select, textarea').forEach((input) => {
          const keyLabel = document.querySelector(`label[for*="${input.name}"]`)?.dataset?.label || input.name;
          if (keyLabel.indexOf('customer[') == -1) {
            if (keyLabel.toLowerCase().indexOf('email') > -1) {
              userData.email = input.value;
              formData.form_email = input.value;
            }
            if (keyLabel.toLowerCase().indexOf('phone') > -1) {
              userData.phone = input.value;
              formData.form_phone = input.value;
            }
            if (keyLabel.toLowerCase().indexOf('name') > -1) {
              userData.name = input.value;
              formData.form_user_name = input.value;
            } 
            if (firstTextAreaFound == false && input.type == 'textarea') {
              formData.form_notes = input.value;
              firstTextAreaFound = true;
            } 
          }
          if (input.value) {
            formData[keyLabel] = input.value;
          }
        });

        if (document.title && location.href?.indexOf('/products/') > -1) formData.product_title = document.title;

        // delay form submission to allow for validation to complete
        setTimeout(function () {
          formData.form_name =
            e.target.closest('[data-section-id')?.dataset.sectionId ||
            Globo.FormBuilder.forms[form.dataset.id].elements[0].label.en;
          formData.action = form.action;

          if (e.target.querySelector('.has-error')) {
            // console.log('form_error', { id: `Globo Form ${e.target.dataset.id}`, ...formData });
            Shopify.analytics.publish('form_error', {
              id: `Globo Form ${e.target.dataset.id}`,
              action: form.action,
              ...formData,
              ...userData
            });
            return;
          }

          if (Globo.FormBuilder.forms[form.dataset.id].elements[0].label.en == 'Trade Form') {
            Shopify.analytics.publish('trade_application_submitted', {
              id: `Globo Form ${e.target.dataset.id}`,
              ...formData,
              ...userData
            });
            window.dispatchEvent(new Event('trade_application_submitted'));
          }

          // change event to standard "form_submitted" event when Shopify enables this (it is blocked for now)
          // console.log('form_completed', { id: `Globo Form ${e.target.dataset.id}`, ...formData });
          Shopify.analytics.publish('form_completed', {
            id: `Globo Form ${e.target.dataset.id}`,
            ...formData,
              ...userData
          });
        }, 500);
      });
    });
  }
});

// Fire exited_site event when user leaves the page (pageLeave) - doesn't work without page interaction (in form)
// window.addEventListener('beforeunload', function(e) {
//   Shopify.analytics.publish("exited_site", { url: window.location.href });
// });

// Trigger delayedLoad event 5s after page is fully loaded or on first interaction

let delayedLoadTimeStamp = new Date().getTime();
let delayedLoadFullDelay = 5000;
let delayedLoadMinDelay = 3000;
let delayedLoadFired = false;
let delayedLoadTimeout = null;

window.addEventListener('load', function () {
  if (delayedLoadFired) return;
  delayedLoadTimeout = setTimeout(fireDelayedLoad, delayedLoadFullDelay);
});
window.addEventListener('touchstart', fireDelayedLoad);
window.addEventListener('mousemove', fireDelayedLoad);

function fireDelayedLoad(e) {
  if (delayedLoadFired) return;

  // if is less than 3 seconds from delayedLoadTimeStamp, trigger fireDelayedLoad at 3s
  const currentTime = new Date().getTime();
  if (currentTime - delayedLoadTimeStamp < delayedLoadMinDelay || currentTime - delayedLoadTimeStamp < 2000) {
    // console.log(
    //   'delayedLoad event triggered by user interaction',
    //   delayedLoadMinDelay - (currentTime - delayedLoadTimeStamp)
    // );
    delayedLoadTimeout = setTimeout(fireDelayedLoad, delayedLoadMinDelay - (currentTime - delayedLoadTimeStamp));
    window.removeEventListener('touchstart', fireDelayedLoad);
    window.removeEventListener('mousemove', fireDelayedLoad);
    return;
  }

  delayedLoadFired = true;
  window.dispatchEvent(new Event('delayedLoad'));
  window.publish('delayedLoad');
  window.removeEventListener('touchstart', fireDelayedLoad);
  window.removeEventListener('mousemove', fireDelayedLoad);
  clearTimeout(delayedLoadTimeout);
  // console.log('delayedLoad event dispatched');
}

// clear session from console
function clearSession() {
  localStorage.removeItem('sessionId');
  localStorage.removeItem('sessionStartTime');
  localStorage.removeItem('lastEvent');
  localStorage.removeItem('sessionData');
  // console.log('Session cleared');
}
